<template>
  <TimeSelectButton
    v-if="!isAllDay && isEditable"
    :is-editable="isEditable"
    :is-edited="isEdited"
    :is24h-format="is24hFormat"
    :current-time="currentDaytime"
    @update:time="onTimeUpdate"
  />
  <BaseButton
    v-else-if="!isAllDay"
    kind="auxiliary"
    state="disabled"
    :text="formatedStartTime"
  />
</template>
<script lang="ts">
import { computed, defineComponent, PropType, toRefs } from "vue";

import type { Locale } from "@ctrl/controller";
import type { Daytime, EventTime } from "@ctrl/controller-rpc";

import BaseButton from "@/components/base/BaseButton.vue";
import { getDaytime } from "@/components/dates";
import { UseSettings } from "@/components/settings/controller/settings";

import TimeSelectButton from "./TimeSelectButton.vue";

export default defineComponent({
  components: {
    BaseButton,
    TimeSelectButton,
  },
  props: {
    eventTime: { type: Object as PropType<EventTime>, required: true },
    isEditable: { type: Boolean, required: true },
    isEdited: { type: Boolean, required: true },
    locale: { type: Object as PropType<Locale>, required: true },
  },
  emits: {
    "update:startTime": (_time: Daytime) => true,
  },
  setup(props, { emit }) {
    const { eventTime, locale } = toRefs(props);
    const { is24hFormat } = UseSettings.getInstance();

    const isAllDay = computed(() => !("start_time" in eventTime.value));

    const formatedStartTime = computed<string>(() => {
      if ("start_time" in eventTime.value) {
        return locale.value.formatDaytime(
          getDaytime(eventTime.value.start_time)
        );
      }
      return "";
    });

    const currentDaytime = computed<
      { hours: number; minutes: number } | undefined
    >(() => {
      if ("start_time" in eventTime.value) {
        const daytime = getDaytime(eventTime.value.start_time);
        return {
          hours: daytime.hours,
          minutes: daytime.minutes || 0,
        };
      }
      return undefined;
    });

    const onTimeUpdate = (time: Daytime) => {
      emit("update:startTime", time);
    };

    return {
      currentDaytime,
      formatedStartTime,
      is24hFormat,
      isAllDay,
      onTimeUpdate,
    };
  },
});
</script>
